import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=16293040&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=16293040&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16293040",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/votech/Documents/project/web/wave-writer-joecig/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16293040')) {
      api.createRecord('16293040', component.options)
    } else {
      api.reload('16293040', component.options)
    }
    module.hot.accept("./ResetPassword.vue?vue&type=template&id=16293040&scoped=true", function () {
      api.rerender('16293040', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ResetPassword.vue"
export default component.exports